import { ref } from 'vue'

export default () => ({
  items: ref([])
})
